<app-de-wrapper>
  <app-spinner></app-spinner>
</app-de-wrapper>
